module.exports = __webpack_public_path__ + "static/budgetlol-9092d6bf3897cc24ecc9ed5081010980.png";